/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-industry-attributes" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-industry-attributes" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-industry-attributes" */ `./edit.vue` );

export default {
	path: `industry-attributes`,
	children: [
		{
			path: ``,
			name: `list-industry-attributes`,
			component: List,
			meta: {
				title: `Industry Attributes`
			}
		},
		{
			path: `new`,
			name: `add-industry-attributes`,
			component: Add,
			meta: {
				title: `Add Industry Attributes`
			}
		},
		{
			path: `:uuid`,
			name: `edit-industry-attributes`,
			component: Edit,
			meta: {
				title: `Edit Industry Attributes`
			}
		}
	]
};
